// WCAG contrast helpers for the brand editor — keeps chosen colours readable.
const clamp = (n) => Math.max(0, Math.min(255, n));

export const normalizeHex = (hex) => {
  let h = (hex || "").trim().replace(/^#/, "");
  if (h.length === 3) h = h.split("").map((c) => c + c).join("");
  return /^[0-9a-fA-F]{6}$/.test(h) ? `#${h.toLowerCase()}` : null;
};

const toRgb = (hex) => {
  const h = normalizeHex(hex);
  if (!h) return null;
  return [0, 2, 4].map((i) => parseInt(h.slice(1 + i, 3 + i), 16));
};

const toHex = (rgb) => "#" + rgb.map((v) => clamp(Math.round(v)).toString(16).padStart(2, "0")).join("");

const lum = ([r, g, b]) => {
  const a = [r, g, b].map((v) => {
    v /= 255;
    return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
  });
  return 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2];
};

export const contrastRatio = (c1, c2) => {
  const a = toRgb(c1), b = toRgb(c2);
  if (!a || !b) return 1;
  const l1 = lum(a), l2 = lum(b);
  return (Math.max(l1, l2) + 0.05) / (Math.min(l1, l2) + 0.05);
};

// Best readable text colour (white or near-black) for a given background.
export const bestTextOn = (bg) => (contrastRatio(bg, "#ffffff") >= contrastRatio(bg, "#0b0f14") ? "#ffffff" : "#0b0f14");

// Nudge a colour darker until white text on it reaches the target ratio (AA for bold/large UI text ≈ 3, body ≈ 4.5).
export const suggestAccessible = (hex, target = 4.5) => {
  let rgb = toRgb(hex);
  if (!rgb) return hex;
  for (let i = 0; i < 40 && contrastRatio(toHex(rgb), "#ffffff") < target; i++) {
    rgb = rgb.map((v) => v * 0.9);
  }
  return toHex(rgb);
};
